import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { whatsappLink, WHATSAPP_DISPLAY } from "@/config";

export default function FloatingWhatsApp() {
    const [open, setOpen] = useState(false);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 320);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    className="fixed bottom-6 right-6 z-[9998] flex flex-col items-end gap-3"
                    initial={{ opacity: 0, scale: 0.6, y: 20 }}
                    animate={{ opacity: 1, scale: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.6, y: 20 }}
                    transition={{ type: "spring", stiffness: 260, damping: 20 }}
                >
                    <AnimatePresence>
                        {open && (
                            <motion.div
                                initial={{ opacity: 0, y: 12, scale: 0.9 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                exit={{ opacity: 0, y: 12, scale: 0.9 }}
                                className="w-64 rounded-lg bg-white p-4 shadow-2xl ring-1 ring-[var(--fama-border)]"
                                data-testid="floating-whatsapp-card"
                            >
                                <div className="flex items-start justify-between gap-2">
                                    <p className="font-serif-display text-xl leading-tight text-[var(--fama-ink)]">
                                        Parliamone insieme
                                    </p>
                                    <button
                                        onClick={() => setOpen(false)}
                                        aria-label="Chiudi"
                                        data-testid="floating-whatsapp-close"
                                        className="text-[var(--fama-ink-soft)] transition-colors hover:text-[var(--fama-ink)]"
                                    >
                                        <X size={16} />
                                    </button>
                                </div>
                                <p className="mt-1 font-body text-sm text-[var(--fama-ink-soft)]">
                                    Scrivici su WhatsApp, senza impegno. Ti
                                    rispondiamo a breve.
                                </p>
                                <a
                                    href={whatsappLink()}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    data-testid="floating-whatsapp-chat-link"
                                    className="mt-3 flex items-center justify-center gap-2 rounded-md bg-[var(--wa-green)] px-4 py-2.5 font-body text-sm font-semibold text-white transition-colors hover:bg-[var(--wa-green-hover)]"
                                >
                                    <WhatsAppIcon size={18} /> Apri la chat
                                </a>
                                <p className="mt-2 text-center font-body text-xs text-[var(--fama-ink-soft)]">
                                    {WHATSAPP_DISPLAY}
                                </p>
                            </motion.div>
                        )}
                    </AnimatePresence>

                    <motion.button
                        onClick={() => setOpen((v) => !v)}
                        whileHover={{ scale: 1.06 }}
                        whileTap={{ scale: 0.94 }}
                        aria-label="Contattaci su WhatsApp"
                        data-testid="floating-whatsapp-button"
                        className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[var(--wa-green)] text-white shadow-xl"
                    >
                        <span className="absolute inset-0 animate-ping rounded-full bg-[var(--wa-green)] opacity-30" />
                        <WhatsAppIcon size={28} className="relative" />
                    </motion.button>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
